import { render, staticRenderFns } from "./gozi-report.vue?vue&type=template&id=20592624"
import script from "./gozi-report.vue?vue&type=script&lang=js"
export * from "./gozi-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports